var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"verifiedMobileNotFound"}},[_c('h3',[_vm._v(_vm._s(_vm._f("localize")("login.verified.mobile.not.found.title")))]),_c('p',[_vm._v(_vm._s(_vm.content))])])
}
var staticRenderFns = []

export { render, staticRenderFns }